import './style.scss';
import { useAppSelector } from '../../redux/hooks';
import AppSearchResultRow from '../../components/app_searchResultRow/AppSearchResultRow';

function AppSearchResultRows() {
	const explorePopularProfiles = useAppSelector((state) => state.search.explorePopularProfiles)
	const exploreMaleProfiles = useAppSelector((state) => state.search.exploreMaleProfiles)
	const exploreFemaleProfiles = useAppSelector((state) => state.search.exploreFemaleProfiles)

	return (
		<div className='section-content section-content-removed-padding'>
			<AppSearchResultRow
				label='Popular Instructors'
				profiles={explorePopularProfiles}
			/>
			<AppSearchResultRow
				label='Female Instructors'
				profiles={exploreFemaleProfiles}
			/>
			<AppSearchResultRow
				label='Male Instructors'
				profiles={exploreMaleProfiles}
			/>
		</div>
	)
}

export default AppSearchResultRows
